<template>
  <card :elevation="elevation" :data-uuid="uuid" :class="[baseCss]" :style="{width}" :bg-color="bgColor" :bg-color-lightness="bgColorLightness">
    <card-text padding-off :class="[dense ? 'p-0' : 'p-2']">
      <table-layout>
        <row>
          <cell v-for="(item, index) in segments" :key="index">
            <time-picker-spinner
              ref="spinner"
              :buttons="buttons"
              :disabled="disabled"
              :color="color"
              :color-lightness="colorLightness"
              :separator="separator"
              :icon-size="iconSize"
              :icon-provider="iconProvider"
              :show-separator="separator && (index > 0 && item !== 'am/pm')"
              :segment="item"
              :icon-up="iconUp"
              :icon-down="iconDown"
              :initial-state="initialState[item]"
              :hour-cycle="item === 'hours' ? hourCycle : null" />
          </cell>
        </row>
      </table-layout>
      <reactive-style>
      .bcq-time-picker[data-uuid="{{ uuid }}"] .bcq-text-field input,
      .bcq-time-picker[data-uuid="{{ uuid }}"] .bcq-time-picker-spinner-separator
      {
        text-align: center;
        font-size: {{ fontSize }}em;
      }
      </reactive-style>
    </card-text>
  </card>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'
import TimePickerSpinner from './time-picker-spinner'

export default {
  name: 'TimePicker',
  components: {
    TimePickerSpinner
  },
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      uuid: this.$uuidv4(),
      baseCss: this.componentBaseCss('time-picker', [])
    }
  },
  props: {
    padZero: {
      type: Boolean,
      default: true
    },
    iconUp: {
      type: String,
      default: 'chevron-up'
    },
    iconDown: {
      type: String,
      default: 'chevron-down'
    },
    buttons: {
      type: Boolean,
      default: true
    },
    fontSize: {
      type: Number,
      default: 1.75
    },
    iconSize: {
      type: Number,
      default: 1.75
    },
    dense: {
      type: Boolean
    },
    color: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    colorLightness: {
      type: Number
    },
    bgColor: {
      type: String
    },
    bgColorLightness: {
      type: Number
    },
    width: {
      type: String
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    hourCycle: {
      type: String,
      default: 'h23',
      validator: value => {
        return [
          'h11',
          'h12',
          'h23',
          'h24'
        ].includes(value)
      }
    },
    initialState: {
      type: Object,
      default: () => {
        return {
          hours: 0,
          minutes: 0,
          seconds: 0,
          'am/pm': 'am'
        }
      }
    },
    separator: {
      type: String,
      default: ':'
    },
    segments: {
      type: Array,
      default: () => {
        return [
          'hours',
          'minutes',
          'seconds',
          'am/pm'
        ]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/time-picker/time-picker.vue